import styled from '@emotion/styled'

import tokens from '../../design/tokens'

export const StyledContainer = styled.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;

  height: 36px;
  background-color: var(--mercury01);
  border-radius: ${tokens.borderRadius.medium};

  & > :first-of-type {
    border-top-left-radius: ${tokens.borderRadius.medium};
    border-bottom-left-radius: ${tokens.borderRadius.medium};
  }

  & > :last-child {
    border-top-right-radius: ${tokens.borderRadius.medium};
    border-bottom-right-radius: ${tokens.borderRadius.medium};
    padding-right: ${tokens.grid.gutter};
  }
`

const handleElementStyle = (enabled, active) => {
  return !enabled
    ? `
      color: var(--silver-chalice03);
      cursor: default;
    `
    : active
    ? `
      background-color: var(--silver02);
      color: var(--pure-white);
      font-weight: ${tokens.fontWeight.bold};
      cursor: default;
      
      &:hover {
        color: var(--pure-white);
      }

    `
    : `
      color: var(--boulder);
      font-weight: ${tokens.fontWeight.bold};
      cursor: pointer;

      &:hover {
        color: var(--mine-shaft);
      }
    `
}

const handleSeparator = separatorType => {
  return separatorType
    ? `
    &::after {
      position: absolute;
      right: 0;
      height: 36px;
      width: 14px;
      content: '';
      
      background-repeat: no-repeat;
      background-size: 14px 36px;
      background-position: 1px 0;
      ${
        separatorType === 'light|dark'
          ? `background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns%3D%22http%3A//www.w3.org/2000/svg%22 viewBox%3D%220 0 14 36%22%3E%0A  %09%3Cpath d%3D%22M0 0 L11 18 L0 36%22 fill%3D%22%23E9E9E9%22/%3E%0A%09%3Cpath d%3D%22M0 0 L11 18 L0 36 L3 36 L14 18 L3 0%22 fill%3D%22%23f5f5f5%22/%3E%0A    %3Cpath d%3D%22M3 0 L14 18 L3 36 L14 36 L14 0 L3 0%22 fill%3D%22%23B9B9B9%22/%3E%0A  %3C/svg%3E');`
          : separatorType === 'dark|light'
          ? `background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns%3D%22http%3A//www.w3.org/2000/svg%22 viewBox%3D%220 0 14 36%22%3E%0A  %09%3Cpath d%3D%22M0 0 L11 18 L0 36 L0 0%22 fill%3D%22%23B9B9B9%22/%3E%0A    %3Cpath d%3D%22M3 0 L14 18 L3 36 L14 36 L14 0 L3 0%22 fill%3D%22%23E9E9E9%22/%3E%0A    %3Cpath d%3D%22M0 0 L11 18 L0 36 L3 36 L14 18 L3 0%22 fill%3D%22%23f5f5f5%22/%3E%0A  %3C/svg%3E');`
          : `background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns%3D%22http%3A//www.w3.org/2000/svg%22 viewBox%3D%220 0 14 36%22%3E%3Cpath d%3D%22M0 0 L11 18 L0 36 L3 36 L14 18 L3 0%22 fill%3D%22%23F5F5F5%22/%3E%3C/svg%3E');`
      }
    }
  `
    : ''
}

export const StyledElementWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 0 ${(3 * tokens.grid.gutterN) / 2}px 0 ${tokens.grid.gutterN}px;

  font-size: 15px;
  font-weight: ${tokens.fontWeight.normal};

  position: relative;

  transition: color 0.25s ease;

  ${({ enabled, active, separatorType }) => `
    ${handleElementStyle(enabled, active)}
    ${handleSeparator(separatorType)}
  `}
`

export const StyledElement = styled.span`
  display: block;
  height: 36px;
  line-height: 36px;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
